export default "__VITE_ASSET__CPPOrNG5__"